var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.paramsAseguradora.isPago == 'true')?_c('pagoEmisionSuccess'):_c('pagoEmisionError')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }